import React from "react";
import Wrapper from "../../../../hoc/Wrapper/Wrapper";
import { Button, Dialog, DialogContent } from "@material-ui/core";
import {
  Document,
  Font,
  Page,
  PDFDownloadLink,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import iransans from "../../../../assets/fonts/vazir/Farsi-Digits-Without-Latin/Vazir-FD-WOL.ttf";
import { nameVariables } from "../CarContractItems";
import momentJalai from "moment-jalaali";
import TextPdfFix from "../../../UI/TextPdfFix";

function formatCurrency(n, currency) {
  return (
    currency +
    n.toFixed(0).replace(/./g, function (c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    })
  );
}

const CarContractSalePrint = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const { data } = props;

  return (
    <Wrapper>
      <Button variant={"outlined"} onClick={(e) => setOpenModal(true)}>
        چاپ اقساطی
      </Button>
      <Dialog
        open={openModal}
        onClose={(e) => setOpenModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <PDFDownloadLink
            document={
              <CarCOntractPdfGenerator data={data} title={"فرم معامله ماشین"} />
            }
            fileName="download_pdf.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? "در حال آماده سازی فایل ..." : "دانلود نمایید!"
            }
          </PDFDownloadLink>
        </DialogContent>
      </Dialog>
    </Wrapper>
  );
};

const Table = ({ children }) => (
  <View
    style={{
      marginTop: 8,
      marginBottom: 8,
      // borderTop: "1 solid black",
      // borderLeft: "1 solid black",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {children}
  </View>
);

const TableRow = ({ style, children }) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      textAlign: "center",
      ...style,
    }}
  >
    {children}
  </View>
);

const TableCell = ({ style, children }) => (
  <View
    style={{
      flex: 1,
      // borderRight: "1 solid black",
      // borderBottom: "1 solid black",
      paddingRight: 3,
      paddingTop: 3,
      paddingBottom: 3,
      textAlign: "right",
      direction: "ltr",
      ...style,
    }}
  >
    <Text>{children}</Text>
  </View>
);

const CarCOntractPdfGenerator = (props) => {
  Font.register({
    family: "IRANSans",
    src: iransans,
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      fontFamily: "IRANSans",
      fontSize: 10,
    },
    header: {
      fontSize: 18,
      textAlign: "right",
    },
    cellHeader: {
      fontSize: 8,
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
    },
  });

  let deliver_item = JSON.parse(props.data.delivered_items);

  const showItems = (item) => {
    return item ? <Text style={{ color: "green" }}>دارد</Text> : "-";
  };

  return (
    <Document
      file="somefile.pdf"
      onLoadSuccess={(e) => {
      }}
    >
      <Page size="A4" style={styles.body}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <View>
            <View>
              <Text>
                {props.data.document_number}
                شماره سند :
              </Text>
            </View>
            <View>
              <Text>
                {props.data.document_date_fa}
                تاریخ سند :
              </Text>
            </View>
          </View>
          <View style={{ width: 300, textAlign: "center", direction: "rtl" }}>
            <Text>به نام خدا</Text>
            <Text>قرارداد فروش اقساطی</Text>

            <Text>غیر قابل انتقال</Text>
          </View>

          <View
            style={{
              paddingTop: 5,
              textAlign: "right",
              fontSize: 13,
              width: 100,
            }}
          >
            <Text>بنگاه فریدونی</Text>
          </View>
        </View>

        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text>فروشنده :</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.id_number}
                شماره شناسنامه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.father}
                فرزند :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.lastname} {props.data.Seller.name}
                آقا یا خانم :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.postal_code}
                کد پستی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.id_card_number}
                شماره ملی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.place_of_issuance}
                صادره از :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Seller.mobile).join(",")}
                شماره همراه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Seller.phone).join(",")}
                تلفن ثابت :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                <TextPdfFix text={props.data.Seller.address} />
                آدرس :
              </TableCell>
            </TableRow>
          </Table>
        </View>

        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>خریدار</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.id_number}
                شماره شناسنامه :{" "}
              </TableCell>

              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.father}
                فرزند :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.lastname} {props.data.Buyer.name}
                آقا یا خانم :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.postal_code}
                کد پستی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.id_card_number}
                شماره ملی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.place_of_issuance}
                صادره از :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Buyer.mobile).join(",")}
                شماره همراه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Buyer.phone).join(",")}
                تلفن ثابت :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                <TextPdfFix text={props.data.Buyer.address} />
                آدرس :
              </TableCell>
            </TableRow>
          </Table>
        </View>
        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>مورد واگذاری</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell
                style={{ border: "none", flex: "auto", width: "120px" }}
              >
                {props.data.manufacture_date}
                سال ساخت :{" "}
              </TableCell>
              <TableCell
                style={{ border: "none", flex: "auto", width: "120px" }}
              >
                {props.data.car_color}
                رنگ :
              </TableCell>
              <TableCell style={{ border: "none", flex: "auto", width: "290" }}>
                {props.data.car_type}
                یک دستگاه خودروی سواری :{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.chassis_number}
                شماره شاسی :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.vin_number}: VIN شماره
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.motor_number}
                شماره موتور :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.current_tag}
                پلاک اتتظامی شماره :{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.remained
                  ? formatCurrency(props.data.remained, "")
                  : 0}
                {" : "} الباقی ثمن معامله{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.prepayment
                  ? formatCurrency(props.data.prepayment, "")
                  : ""}
                {" : "} پیش پرداخت
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.price ? formatCurrency(props.data.price, "") : ""}
                {" : "} کل ثمن معامله
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                فقره چک به شرح پشت این قرارداد توسط خریدار به فروشنده پرداخت
                گردید و خریدار در نهایت صحت و سلامت اقرار به
                {props.data.cheques ?? 0}
                می باشد که طی
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                استطاعت مالی کافی جهت پرداخت کلیه چک های مذکور را نمود.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                خریدار حق هرگونه طرح دعوی اعسار و تقسیط در خصوص پرداخت چک های
                مذکور را از خود سلب نمود و بر تمکن مالی و ملائت
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 1
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>خود اقرار دارد.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                خودروی مذکور شامل مستثنیات دین خریدار نمی باشد.
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 2
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                در صورت عدم وصول هر کدام از چک های مذکور در قرارداد علاوه بر 01
                درصد اصل مبلغ چک، روزانه 1 درصد اصل مبلغ چک به عنوان
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 3
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>خسارت خریدار به فروشنده بپردازد.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                در صورت عدم وصول چک های مذکور، کلیه هزینه هایی که توسط فروشنده
                بابت اقدام قانونی اعم از هزینه دادرسی و کل هزینه
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 4
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                وکیل و غیره پرداخت گردد به عهده خریدار می باشد.
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                چنانچه هر کدام از چک های ثمن معامله به هر علتی برگشت خورده و وجه
                آن به فروشنده پرداخت نشود برای فروشنده، حق فسخ
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 5
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                معامله حاضر ایجاد می گردد که از تاریخ ابلاغ اظهارنامه رسمی فسخ
                معامله به خریدار باید خودرو عینا به فروشنده استرداد نماید و در
                غیر
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {" "}
                این صورت مطابق ماده 136 قانون مدنی مصداق خیانت در امانت محسوب می
                شود . ضمنا تا زمان استرداد خودرو به فروشنده بند 3 این
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>قرارداد قابل اجرا است.</TableCell>
            </TableRow>
            <TableRow style={{ paddingTop: 15 }}>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای خریدار
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای فروشنده
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                خریدار به هیچ وجه و تحت هیچ عنوان حق واگذاری خودروی مذکور را به
                شخص یا اشخاص دیگر ندارد، در غیر اینصورت معامله دوم
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 6
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                باطل و بی اعتبار است و فروشنده حق فسخ معامله اول و حق ابطال
                معامله دوم را دارد.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                فقط خلافی و عوارض شهرداری تا تاریخ این قرارداد به عهده فروشنده و
                از این تاریخ به بعد به عهده خریدار است.
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 7
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                بعد از اتمام و وصول کلیه چک ها و تسویه حساب کامل سند مالکیت
                خودرو به صورت وکالت فروش با 01 روز اعتبار جهت تعویض
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 8
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ textAlign: "justify" }}>
                پلاک به نام خریدار یا هر شخصی که خریدار کتبا معرفی نماید تنظیم و
                فقط شناسنامه مالکیت سبز به علاوه وکالت فروش تحویل خریدار
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                می گردد و الباقی مدارک اعم از فاکتور فروش و بنچاق قطعی ایادی
                قبلی نزد فروشنده خواهد ماند و خریدار متعهد می گردد ظرف مدت 01
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                روز پلاک فروشنده را فک و تاییدیه تعویض پلاک بعلاوه عدم خلاف پلاک
                فروشنده را به وی تحویل و الباقی مدارک خود را تحویل بگیرد در غیر
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                اینصورت پلاک فروشنده نزد خریدار امانت بوده و طبق ماده 136 قانون
                مدنی مصداق خیانت در امانت خواهد بود که طبق قانون بخورد خواهد
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>شد.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                کل هزینه نقل و انتقال سند به صورت کامل و خلافی و عوارض شهرداری و
                مالیات و دارایی و هرگونه دیونات دولتی بهعهده خریدار
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 9
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>می باشد.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                چنانچه به هر دلیلی این قرارداد منجر به اقدام قانونی گردد، بعد از
                اینکه خودروی مذکور عودت گردید، خودرو به نرخ روز توسط
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 01
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                سه واحد صنفی نمایشگاه و فروشگاه خودرو واقع در منطقه شهرری
                قیمت‌گذاری شده و کلیه کسورات و هزینه های بند های قبلی از پرداختی
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                های خریدار کسر و الباقی آن بعد از تسویه حساب کامل کل دیونات
                دولتی اعم از خلافی راهنمایی و رانندگی و عوارض شهرداری ،مالیات
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>دارایی، به خریدار پرداخت خواهد شد.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                به دلیل نوسانات لحظه ای قیمت کلیه خیارات،حتی خیار غبن و تدلیس از
                طرفین ساقط شد.
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 11
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                کل این قرار داد و عین 21 بند آن در نهایت صحت و سلامت عقلی و جسم
                و با آگاهی کامل از عوارض ناشی از آن و بدون هیچ اجبار
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 21
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                و تردید در حضور شاهدین که حضورشان مورد تایید طرفین می باشد با
                دقت مطالعه و تفهیم و مورد تایید قرار گرفت.{" "}
              </TableCell>
            </TableRow>
          </Table>
        </View>

        <View>
          <Table>
            <TableRow>
              <TableCell>
                با کلیه متعلقات و
                {momentJalai(props.data.delivery_date)
                  .format("jDD-jMM-jYYYY")
                  .split("")
                  .reverse()
                  .join("")}
                {"  "}
                {momentJalai(props.data.delivery_date)
                  .format("HH:mm")
                  .split("")
                  .reverse()
                  .join("")}
                خودرو مذکور راس ساعت
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {showItems(deliver_item.key_card)}: {nameVariables.key_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.spare_key)}: {nameVariables.spare_key}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.body_insurance)}:{" "}
                {nameVariables.body_insurance}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.third_party_insurance)}:{" "}
                {nameVariables.third_party_insurance}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.id_card)}: {nameVariables.id_card}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {showItems(deliver_item.technical_inspection)}:{" "}
                {nameVariables.technical_inspection}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.mayoralty_charges)}:{" "}
                {nameVariables.mayoralty_charges}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.fuel_card)}: {nameVariables.fuel_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.golden_card)}:{" "}
                {nameVariables.golden_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.garranty_card)}:{" "}
                {nameVariables.garranty_card}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                توسط فروشنده به خریدار تحویل گردید.
                {"  "}
                {props.data.inspection_date
                  ? momentJalai(props.data.inspection_date)
                      .format("jDD-jMM-jYYYY")
                      .split("")
                      .reverse()
                      .join("")
                  : ""}
                {"  "}
                {props.data.inspection_date
                  ? momentJalai(props.data.inspection_date)
                      .format("HH:mm")
                      .split("")
                      .reverse()
                      .join("")
                  : ""}
                {"  "}
                تاریخ
                {"  "}
                {props.data.inspection_center}
                {"  "}و تاییدیه کارشناسی مرکز
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>شرایط پرداخت</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextPdfFix text={props.data.payment_terms} />
              </TableCell>
            </TableRow>
            <TableRow style={{ paddingTop: 30 }}>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای خریدار
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای فروشنده
              </TableCell>
            </TableRow>
          </Table>
        </View>
      </Page>
    </Document>
  );
};
export default CarContractSalePrint;
